<template>
  <TimeSelectPopover
    v-model="time"
    :startHour="startHour"
    :clearButton="clearButton"
    :disabled="disabled"
    :small="small"
    :length="length"
    :limit="limit"
  >
    <div class="time-input" :class="{ disabled, small: small }">
      <template v-if="jaWord">{{ value ? formatTime(value) : '未設定' }}</template>
      <template v-else><ClockIcon v-if="!small" />{{ value ? formatTime(value) : '−−：−−' }}</template>
    </div>
  </TimeSelectPopover>
</template>

<script>
import { formatTime } from '@/utils/time'
import TimeSelectPopover from '@/components/molecules/TimeSelectPopover'
import ClockIcon from '@/components/icons/clock'

/**
 * 時刻入力
 */
export default {
  name: 'TimeInput',
  components: {
    TimeSelectPopover,
    ClockIcon,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /** 時刻 (v-model) */
    value: String,
    /** 先頭の選択時 */
    startHour: { type: Number, default: 0 },
    /** クリアボタン */
    clearButton: Boolean,
    /** 非活性 */
    disabled: Boolean,
    /** スモールモダール */
    small: Boolean,
    /** 未設定文言 */
    jaWord: { type: Boolean, default: false },
    /** 選択時間数 */
    length: { type: Number, default: 24 },
    /** 時間制限 */
    limit: { type: Number, default: 30 },
  },
  computed: {
    time: {
      get() {
        return this.value
      },
      set(time) {
        /**
         * 時刻変更 (v-model)
         * @event change
         * @type String
         */
        this.$emit('change', time)
      },
    },
  },
  methods: {
    formatTime,
  },
}
</script>

<style lang="postcss" scoped>
.time-input {
  align-items: center;
  background: var(--white);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  display: grid;
  fill: var(--moderate-blue);
  font-size: 13px;
  grid-auto-flow: column;
  grid-gap: 8px;
  height: 40px;
  justify-content: start;
  line-height: 16px;
  padding: 0 8px;
  position: relative;
  width: 100%;
}

.small {
  font-size: 15px;
  padding: 0 36px 0 16px;
  width: 126px;

  &::after {
    border: 5px solid transparent;
    border-left: 5px solid #757575;
    box-sizing: border-box;
    content: '';
    height: 5px;
    pointer-events: none;
    position: absolute;
    right: 16px;
    top: 18px;
    transform: rotate(90deg);
    width: 5px;
  }
}

.disabled {
  background: var(--very-light-gray-3);
  cursor: default;
  fill: var(--very-dark-gray-2);
}
</style>
